import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCategories = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    style={{
      color: 'inherit',
      fill: 'currentcolor',
      ...props.style,
    }}
  >
    <rect height="25.14" rx="3" width="25.14" x="4" y="4"/>
    <path d="m17.47 35.41a1.04031 1.04031 0 0 0 -1.79 0l-11.57 23.14a.99538.99538 0 0 0 .89 1.45h23.14a1.00469 1.00469 0 0 0 .9-1.45z"/>
    <circle cx="47.43" cy="16.57" r="12.57"/>
    <path stroke="currentColor" strokeWidth={4} d="m48.84 47.43 10.87-10.87a.996.996 0 0 0 0-1.41 1.0081 1.0081 0 0 0 -1.42 0l-10.86 10.86-10.87-10.86a.997.997 0 1 0 -1.41 1.41l10.86 10.87-10.86 10.86a1.00792 1.00792 0 0 0 0 1.42 1.02422 1.02422 0 0 0 .71.29 1.0011 1.0011 0 0 0 .7-.29l10.87-10.87 10.86 10.87a1.01409 1.01409 0 0 0 1.42 0 1.008 1.008 0 0 0 0-1.42z"/>
  </svg>
);
